<template>
  <div class="dup__media__call__btn">
    <b-button
      @click="duplicateMediaCallFromProject"
      v-b-tooltip.hover
      title="Duplicate"
      class="duplicate-media-call-btn"
      variant="theme"
    >
      <i class="fas fa-copy"></i>
    </b-button>
  </div>
</template>

<script>
export default {
  props: ['deliverableId', 'namespace'],
  methods: {
    duplicateMediaCallFromProject() {
      let that = this;
      this.$store.dispatch(this.namespace + 'duplicateMediaCallFromProject', {deliverableId: this.deliverableId}).then(function() {
        that.$store.dispatch(that.namespace + 'fetchDeliverables').then(function() {
        	that.$store.dispatch(that.namespace + 'fetchProjectDeliverable').then(function() {
          	that.$store.dispatch(that.namespace + 'manageUndoActivation', 'Deliverable duplicated.');
          });
        });
        that.$bvModal.hide("editDeliverableModal");
        window.scrollTo(0, 0);
      });
    },
  },
};
</script>

<style>
</style>